var $ = require('jquery');
/**
 * Depends: Modul.js
 */
(function() {
    var self = null;
    var LinkSelector = Klazz.extend({
        internalSelect: null,
        internalCombo: null,

        externalSelect: null,
        externalInput: null,

        anchorSelect: null,
        anchorCombo: null,

        displayLinkAsButton: null,

        contentEl: null,

        initialize: function() {
            self = this;
        },

        setContentEl: function(contentEl) {
            if (this.contentEl !== null) {
                this.contentEl.remove();
            }

            this.contentEl = contentEl;
        },

        openDialog: function(linkData, callbackMethod, displayLinkAsButton) {
            var $dialog = null;

            $.ajax({
                url: '/app/module/module/linkselector',
                type: 'POST',
                success: function(response) {
                    $dialog = $(response);

                    self.setContentEl($dialog);
                    $dialog.diy_dialog({
                        width: 400,
                        resizable: false,
                        position: ['center', 'center'],
                        modal: true,
                        dialogClass: 'linkSelector',
                        zIndex: diy.editor.getNewTopZIndex(),
                        buttons: [{
                            text: jimdoData.messages.cancel,
                            click: function() {
                                $dialog.diy_dialog("close");
                            },
                            "class": "button-cancel"
                        }, {
                            text: jimdoData.messages.imageLinkSelector.removeLinkButtonLabel,
                            click: function() {
                                callbackMethod.call(self, {
                                    target: '',
                                    value: '',
                                    href: ''
                                });
                                $dialog.diy_dialog('close');
                            },
                            "class": "button-cancel"
                        },  {
                            text: jimdoData.messages.imageLinkSelector.createLinkButtonLabel,
                            click: function() {
                                callbackMethod.call(self, self.getLinkData());
                                $dialog.diy_dialog('close');
                            }
                        }],
                        close: function() {
                            $dialog.diy_dialog('destroy').remove();
                            self.setContentEl(null);
                        },
                        open: function() {
                            self.initLinkObjects();
                            self.applyFacelift();
                            self.refreshInputs(linkData);

                            self.displayLinkAsButton.parent().toggle(displayLinkAsButton === true);
                        }
                    });
                }
            });
        },

        initLinkObjects: function() {
            this.internalSelect = $('.internalLink', this.contentEl);
            this.internalCombo = $('.combobox-internalLink', this.contentEl);

            this.externalSelect = $('.externalLink', this.contentEl);
            this.externalInput = $('.externalLinkInput', this.contentEl);

            this.anchorSelect = $('.anchorLink', this.contentEl);
            this.anchorCombo = $('.anchorLinkCombo', this.contentEl);

            this.displayLinkAsButton = $('input[name=displayAsButton]', self.contentEl);
        },

        selectLinkType: function(element) {
            this.externalInput.prop('disabled', element != this.externalSelect);
            this.internalCombo.diy_combobox('option','disabled', element != this.internalSelect);
            this.anchorCombo.diy_combobox('option','disabled', element != this.anchorSelect);
        },

        applyFacelift: function() {
            this.internalSelect.diy_radiobox().click(function() {
                self.selectLinkType(self.internalSelect);
            });
            this.externalSelect.diy_radiobox().click(function() {
                self.selectLinkType(self.externalSelect);
            });
            this.anchorSelect.diy_radiobox().click(function() {
                self.selectLinkType(self.anchorSelect);
            });

           this.internalCombo.diy_combobox({
               editable: false,
               renderItem: function (elem, item) {
                   elem.text($(item.option).attr('data-indentation') + item.label);
               }
           });
           this.anchorCombo.diy_combobox({editable: false});

           this.displayLinkAsButton.diy_checkbox();
       },

        refreshInputs: function(linkData) {
            // internal Link
            var selectedElement = this.internalSelect;
            var href = linkData.href;

            if (href && href.substr(0,12) == cc_.internalLinkPrefix) {
                var pageID = href.slice(12, href.lastIndexOf(cc_.internalLinkSuffix));
                this.internalCombo.diy_combobox('option', 'rawValue', pageID);

            } else if (href && href.substr(0,1) == '#') {
                selectedElement = this.anchorSelect;
                this.anchorCombo.diy_combobox('option', 'rawValue', href.slice(1));

            } else if (href) {
                selectedElement = this.externalSelect;
                this.externalInput.val(href.replace("http://", ""));
            }

            this.internalSelect.diy_radiobox('option', 'checked', selectedElement == this.internalSelect);
            this.externalSelect.diy_radiobox('option', 'checked', selectedElement == this.externalSelect);
            this.anchorSelect.diy_radiobox('option', 'checked', selectedElement == this.anchorSelect);

            this.selectLinkType(selectedElement);

            this.displayLinkAsButton.diy_checkbox('option', 'checked', linkData.displayAsButton === true);
        },

        getLinkData: function() {
            var linkData = {
                target: '_blank',
                value: '',
                href: '',
                displayAsButton: this.displayLinkAsButton.diy_checkbox('option', 'checked')
            };

            if (this.internalSelect.is(':checked')) {
                var pageID = this.internalCombo.diy_combobox('option', 'rawValue');
                linkData.href = cc_.internalLinkPrefix + pageID + cc_.internalLinkSuffix;
                linkData.value = this.internalCombo.diy_combobox('value');
                linkData.target = '';

            } else if (this.anchorSelect.is(':checked')) {
                linkData.href = '#' + this.anchorCombo.diy_combobox('option', 'rawValue')    ;
                linkData.value = this.anchorCombo.diy_combobox('value');
                linkData.target = '';
            } else {
                var hyperlinkVal = this.externalInput.val();
                if (hyperlinkVal.substr(0,7) == 'http://') {
                    linkData.href = hyperlinkVal;
                    linkData.value = hyperlinkVal.substr(7);

                } else if (hyperlinkVal.substr(0,8) == 'https://') {
                    linkData.href = hyperlinkVal;
                    $('#linkShow' + this.imageId).val(hyperlinkVal.substr(8));

                } else if (hyperlinkVal.substr(0,7) == 'mailto:') {
                    linkData.href = hyperlinkVal;
                    linkData.value = hyperlinkVal;

                } else if (diy.util.validator.isEmail($.trim(hyperlinkVal))){
                    linkData.href = 'mailto:' + $.trim(hyperlinkVal);
                    linkData.value = linkData.href;

                } else if (hyperlinkVal.length) {
                    linkData.href = 'http://' + hyperlinkVal;
                    linkData.value = hyperlinkVal;
                }
            }

            return linkData;
        },
        destroy: function() {
            this.contentEl.remove();
        }
    });

    module.exports = LinkSelector;
})();



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/common/js/LinkSelector.js
 ** module id = 1134
 ** module chunks = 0
 **/